/**
 * It returns a fragment that contains the ErrorBlock and Footer components
 * @returns A Fragment with an ErrorBlock and a Footer.
 */
import React, { Fragment, useEffect } from 'react';
import detectBrowserLanguage from 'detect-browser-language';
import ErrorBlock from '../components/ErrorBlock/ErrorBlock';
import * as SELECTORS from '../constants/selectors';
import Footer from '../components/Footer/Footer';
import Header from '../components/Header/Header';
const ErrorGeneric = (props) => {
  const errorCode = parseInt(props.errorCode);
  const langCode = detectBrowserLanguage();
  useEffect(() => {
    // Hide 'Hamburger menu'
    const burger = document.querySelector('.nav_dropdown');
    burger && burger.classList.add('hide');
    // Show 'Hamburger menu'
    return () => burger && burger.classList.remove('hide');
  }, []);

  return (
    <Fragment>
      {errorCode === 102 ? <Header selectorKey={SELECTORS.PAGE_NO_ADA_KEY} errorId={errorCode}/> : ''}
      <ErrorBlock errorId={errorCode}/>
      {/* Passing a footerMap prop to the Footer component. */}
      <Footer footerMap={langCode.startsWith('es') ? 'MAP5795539' : 'MAP5789330'}  />
    </Fragment>
  )
}

export default ErrorGeneric;